import { doFetchMetadata } from "actions/metaAction";
import { useCallback, useEffect, useState } from "react";
import KickImage from 'Reuseables/KickImage';

export function useFetchMetadata(page: string) {
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");

  const fetchMetadata = useCallback(async () => {
    try {
      const data = await doFetchMetadata();
      const metaData = data.data.data.find((item: any) => item.page_url === page);
      if (!metaData) return;
      if (!metaData.active) return;
      setMetaTitle(metaData.title);
      setMetaDescription(metaData.description);
    } catch (error) {
      console.log(error)
    }
  }, [page]);

  return {
    metaTitle,
    metaDescription,
    fetchMetadata,
  };
}